//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class GroupModel extends ModelBase {
      static readonly $typeName = 'GroupModel';
      public accessRestriction: LookupModel;
      public key: string;
      public name: string;
      public canEdit: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/GroupModel.ts